import React from 'react';
import { loadRowRequest } from '@/actions';
import { useLazyGetRowRequestMetadataQuery } from '@/features/publicDatasets/publicDatasetApi';
import { RoundedButton } from '@trevor/ui-components';
import { useAppDispatch } from '@/store/hooks';

type ResetQueryButtonProps = {
  initialRowRequest: Nullable<string>;
  onReset: F0;
  datasourceId: string;
};

export const ResetQueryButton: React.FC<ResetQueryButtonProps> = ({
  initialRowRequest,
  onReset,
  datasourceId,
}) => {
  const dispatch = useAppDispatch();
  const [trigger] = useLazyGetRowRequestMetadataQuery();

  const resetLayers = () => {
    dispatch(loadRowRequest(initialRowRequest));
    trigger({ datasourceId, rowRequestId: initialRowRequest });
    onReset();
  };

  return (
    <RoundedButton onClick={resetLayers} $borderRadius="20px" $height="33px">
      Undo changes
    </RoundedButton>
  );
};
